module.exports = __webpack_public_path__ + "static/media/section_1.0ec08003.jpg";